"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanonicalLink = void 0;
var _getCanonicalLinkUrl = require("../internals/getCanonicalLinkUrl");
var _jsxRuntime = require("react/jsx-runtime");
const CanonicalLink = ({
  pathname,
  host
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
  rel: "canonical",
  href: (0, _getCanonicalLinkUrl.getCanonicalLinkUrl)(host, pathname)
});
exports.CanonicalLink = CanonicalLink;
